import { useMemo } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Droplet } from "lucide-react";
import { PALETTE, fmt, fmtMoney, KPI } from "./_shared";

export function WaterTab({ overview, rows }) {
  const monthly = useMemo(() => {
    const m = {};
    for (const r of rows) {
      const key = r.period_month;
      const b = m[key] || (m[key] = { period_month: key, used: 0, recycled: 0 });
      b.used += r.litres_used || 0;
      b.recycled += r.litres_recycled || 0;
    }
    return Object.values(m).sort((a, b) => a.period_month.localeCompare(b.period_month))
      .map((x) => ({ ...x, label: x.period_month.slice(5) }));
  }, [rows]);
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <KPI label="Water Used (L)"      value={fmt(overview.water.litres_used)} icon={Droplet} tone="brand" />
        <KPI label="Water Recycled (L)"  value={fmt(overview.water.litres_recycled)} tone="good" />
        <KPI label="Recycled Pct"        value={`${overview.water.recycled_pct}%`} tone={overview.water.recycled_pct >= 20 ? "good" : "warn"} />
        <KPI label="Water Cost"          value={fmtMoney(overview.water.cost)} />
      </div>
      <div className="rounded-lg border border-slate-200 bg-white p-4">
        <div className="text-sm font-medium text-slate-800 mb-2">Water Used vs Recycled — Monthly</div>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={monthly}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${(v/1000).toFixed(0)}k`} />
            <Tooltip formatter={(v) => `${fmt(v)} L`} contentStyle={{ fontSize: "12px" }} />
            <Legend wrapperStyle={{ fontSize: "11px" }} />
            <Bar dataKey="used"     name="Used"     fill={PALETTE.sky} radius={[4, 4, 0, 0]} />
            <Bar dataKey="recycled" name="Recycled" fill={PALETTE.emerald} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
